import React, { useEffect } from 'react';
import { useAppSelector } from '../store';

export default function useAuthEffect(cb, dp = []) {
  const userId = useAppSelector((state) => state.user.id);

  useEffect(() => {
    if (!userId) return;
    cb();
  }, [userId, ...dp]);
}
